<template>
 <el-dialog
    :title="editTitle"
    width="641px"
    :close-on-click-modal="false"
    :show-close="!forceEditPassword"
    :visible.sync="visible"
    :before-close="close">
    <div class="user-edit-container">
      <p class="warm-tips">{{ warmTips }}</p>
      <div class="user-edit-content">
        <el-form :model="userForm" :rules="rules" ref="userForm" label-width="140px" class="user-form" v-show="editUserFlag">
          <el-form-item label="姓名:" prop="userName">
            <el-input v-model="userForm.userName" class="user-input" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:" prop="email">
            <el-input v-model="userForm.email" class="user-input" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="手机:" prop="mobilePhone">
            <el-input v-model="userForm.mobilePhone" class="user-input" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="QQ:" prop="qq">
            <el-input v-model="userForm.qq" class="user-input" size="mini"></el-input>
          </el-form-item>
          <el-form-item class="user-edit-content-option">
            <el-button size="small" class="el-button--success" type="primary" @click="goEditPassword()">修改密码</el-button>
            <el-button size="small" class="el-button--success" type="primary" @click="submitForm('userForm')">保存</el-button>
            <el-button size="small" class="el-button--info" @click="close()">取消</el-button>
          </el-form-item>
        </el-form>
        <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="140px" class="password-form" v-show="!editUserFlag">
          <el-form-item label="原密码:" prop="oldPassword">
            <el-input type="password" v-model="passwordForm.oldPassword" class="user-input" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="新密码:" prop="newPassword">
            <el-input type="password" v-model="passwordForm.newPassword" class="user-input" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码:" prop="verifyPassword" style="margin-bottom: 80px;">
            <el-input type="password" v-model="passwordForm.verifyPassword" class="user-input" size="mini"></el-input>
          </el-form-item>
          <el-form-item class="user-edit-content-option">
            <el-button size="small" class="el-button--success" type="primary" v-if="!forceEditPassword" @click="goEditUser()">修改我的信息</el-button>
            <el-button size="small" class="el-button--success" type="primary" @click="submitForm('passwordForm')">保存</el-button>
            <el-button size="small" class="el-button--info" @click="close()" v-if="!forceEditPassword">取消</el-button>
            <el-button size="small" class="el-button--info" @click="close()" v-show="isDebug">关闭</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
</el-dialog>
</template>

<script>
import { updateUserAccount, updatePassword, logout } from '@/model/info-model'

export default {
  name: 'userEdit',
  props: {
    warmTips: {
      type: String,
      default: ''
    },
    userInfo: {
      type: Object,
      required: true
    },
    editUserFlag: {
      type: Boolean,
      required: false,
      default: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    forceEditPassword: {
      type: Boolean,
      default: false
    }
  },
  data () {
    let checkphone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入您的手机号'))
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }
    let validatePassword = (rule, value, callback) => {
      const strongRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,18}$/
      const symbolReg = /[\s~`·=!@#$%^&*()\-_=+[\]\\{}|;:'",<.>/?~！@#￥%……&*（）——+|}{“：”；‘’、。，？【】》《]/
      const fontReg = /[\u4e00-\u9fa5]/
      const blankReg = /\s/
      // 判断是否符合要求
      if (blankReg.test(value)) {
        return callback(new Error('您输入的密码不符合条件, 请勿输入空格，请重新输入！'))
      } else if (fontReg.test(value)) {
        return callback(new Error('您输入的密码不符合条件, 请勿输入中文汉字，请重新输入！'))
      } else if (symbolReg.test(value)) {
        return callback(new Error('您输入的密码不符合条件, 请勿输入符号，请重新输入！'))
      } else if (!strongRegex.test(value)) {
        return callback(new Error('您输入的密码不符合条件, 需符合8到18位且只包含大小写字母和数字，请重新输入！'))
      } else {
        callback()
      }
    }
    let confirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入您的新密码'))
      } else {
        if (value !== this.passwordForm.newPassword) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      }
    }
    return {
      userForm: {
        userName: this.userInfo.name,
        email: this.userInfo.email,
        qq: this.userInfo.qq,
        mobilePhone: this.userInfo.mobilePhone,
        role: this.userInfo.role,
        userId: this.userInfo.userId
      },
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        verifyPassword: '',
        userId: this.userInfo.userId
      },
      rules: {
        userName: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
          {
            required: true,
            message: '请填写您的邮箱',
            trigger: 'blur'
          }
        ],
        mobilePhone: [
          { required: true, validator: checkphone, trigger: 'blur' }
        ]
      },
      passwordRules: {
        newPassword: [{
          required: true,
          validator: validatePassword,
          trigger: 'blur'
        },
        { min: 6, message: '长度需大于6个字符', trigger: 'blur' }],
        verifyPassword: [{
          required: true,
          validator: confirmPassword,
          trigger: 'blur'
        },
        { min: 6, message: '长度需大于6个字符', trigger: 'blur' }],
        oldPassword: [{
          required: true,
          message: '请填写您的原密码',
          trigger: 'blur'
        }]
      },
      isDebug: false
    }
  },
  computed: {
    editTitle () {
      return this.editUserFlag ? '修改我的信息' : '修改密码'
    }
  },
  watch: {
    visible(newV) {
      if (newV) {
        document.addEventListener("keydown", this.handleGlobalEvent, true);
      } else {
        document.removeEventListener("keydown", this.handleGlobalEvent, true);
      }
    }
  },
  methods: {
    goEditUser () {
      this.editUserFlag = true
      this.clearValidate('userForm')
    },
    goEditPassword () {
      this.editUserFlag = false
      this.clearValidate('passwordForm')
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editUserFlag) {
            this.updateUserAccount()
          } else {
            this.updatePassword()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    updateUserAccount () {
      updateUserAccount(this.userForm).then(res => {
        console.log(res)
        if (res.result === 'false') {
          this.alertError(res.errorMsg || '更新失败')
        } else {
          this.alertSuccess('更新成功!')
        }
      }).catch(e => {
        this.alertError(e.resp_msg || '更新失败')
      })
    },
    updatePassword () {
      updatePassword({data: this.passwordForm}).then(res => {
        console.log(res)
        if (res.result === 'false') {
          this.alertError(res.errorMsg || '修改失败')
        } else {
          if (this.forceEditPassword) {
            this.$alert('修改成功!请使用新密码重新登录', '修改成功', {
              confirmButtonText: '确定',
              callback: action => {
                sessionStorage.removeItem('weakPassword')
                this.logout()
              }
            })
          } else {
            this.alertSuccess('修改成功!')
          }
        }
      }).catch(e => {
        this.alertError(e.resp_msg || '修改失败')
      })
    },
    close () {
      this.$emit('user-edit-close')
      if (this.editUserFlag) {
        this.clearValidate('passwordForm')
      } else {
        this.clearValidate('userForm')
      }
    },
    clearValidate (formName) {
      this.$nextTick(() => {
        this.$refs[formName].clearValidate()
      })
    },

    logout () {
      let searchUserId = location.search.split('userId=')[1] ? { userId: location.search.split('userId=')[1].split('&')[0] } : null
      let userInfo = JSON.parse(sessionStorage.getItem('user_info')) || searchUserId || (top.GLOBAL ? top.GLOBAL.user : null) || {}
      logout().then(() => {
        sessionStorage.removeItem('login_validate_id')
        localStorage.removeItem(`kw_token-${userInfo.userId}`)
        localStorage.removeItem('kw_refresh_token')
        window.location.href = '/index.html'
      }).catch(err => {
        console.log(err)
        sessionStorage.removeItem('login_validate_id')
        localStorage.removeItem(`kw_token-${userInfo.userId}`)
        localStorage.removeItem('kw_refresh_token')
        window.location.href = '/index.html'
      })
    },
    /**
     * 错误弹窗
     */
    alertError (errorMsg) {
      const h = this.$createElement
      let tipEls = [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--warning`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--warning']
        }, errorMsg)
      ]
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, tipEls)
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success'
      })
    },

    // 成功弹窗
    alertSuccess (msg) {
      const h = this.$createElement
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--success`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--success']
        }, msg)
      ])
      this.$alert(vnode, '', {
        confirmButtonText: '确定',
        center: true,
        showClose: false,
        showCancelButton: false,
        callback: action => {
          this.$emit('user-edit-success')
        }
      })
    },
    handleGlobalEvent () {
      document.onkeydown = (event) => {
        if (event.keyCode === 66 && event.ctrlKey) {
          this.isDebug = true
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.user-edit-container {
  width: 640px;
  .user-edit-header {
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    background: #469064;
    color: #fff;
    position: relative;
    .el-icon-close{
      position: absolute;
      right: 15px;
      top: 12px;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .user-edit-content {
    padding: 20px 0 5px;
    .user-form, .password-form{
      .user-input{
        width: 340px;
        input{
          background: #eae8e4
        }
      }
    }
    .user-edit-content-option{
      text-align: center;
      margin-left: -150px;
    }
  }
  .warm-tips{
    color: red;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserEdit.vue